import { TRACKERID_KEY as e } from "@bytel/logger-web";
import { cookies as r } from "next/headers";
const i = () => ({}), s = async () => {
  const o = (await r()).get(e);
  return o ? o.value : "";
};
export {
  s as getTrackerId,
  i as getUserInfoFromHeaders
};
//# sourceMappingURL=helpers.js.map
